import { Scope as n } from "./chunk885.js";
function s(e) {
  if (e)
    return r(e) ? { captureContext: e } : u(e) ? {
      captureContext: e
    } : e;
}
function r(e) {
  return e instanceof n || typeof e == "function";
}
const o = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function u(e) {
  return Object.keys(e).some((t) => o.includes(t));
}
export {
  s as parseEventHintOrCaptureContext
};
